module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Review Deck URL")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "hide-details": "",
      "error-messages": _vm.reviewDeckURL
    },
    on: {
      "input": function($event) {
        return _vm.$v.reviewDeckURL.$touch()
      },
      "blur": function($event) {
        return _vm.$v.reviewDeckURL.$touch()
      }
    },
    model: {
      value: (_vm.reviewDeckURL),
      callback: function($$v) {
        _vm.reviewDeckURL = $$v
      },
      expression: "reviewDeckURL"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.reviewDeckURL.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a89e0092"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ReviewMeeting/ReviewDeckUrlModal.vue
// module id = 2260
// module chunks = 0